import React from 'react';

import styles from './SettingsInput.module.scss';

import EmailInput from 'Screens/Dashboard/Settings/Inputs/EmailInput/EmailInput';
import NameInput from 'Screens/Dashboard/Settings/Inputs/NameInput/NameInput';
import PasswordChangeButton from 'Screens/Dashboard/Settings/Options/PasswordChangeButton/PasswordChangeButton';
import EmailChangeButton from 'Screens/Dashboard/Settings/Options/EmailChangeButton/EmailChangeButton';
import AddressInput from 'Screens/Dashboard/Settings/Inputs/AddressInput/AddressInput';

const SettingsInputs: React.FC = () => (
    <div className={styles.container}>
        <div className={styles.elements}>
            <NameInput />
            <EmailInput />
        </div>
        <AddressInput />
        <div className={styles.elements}>
            <PasswordChangeButton />
            <EmailChangeButton />
        </div>
    </div>
);

export default SettingsInputs;
